import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CallForPapersViewModel, FinalizePaperModel, PaperApprovalStatus } from 'src/app/_models/generatedModels';
import { CallForPapersService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-final-user-approval',
  templateUrl: 'final-user-approval.component.html',
})
export class FinalUserApprovalComponent implements OnInit {
  initialized = false;
  paperId: number;
  conferenceId: string;
  instructorStatus?: number = null;
  paper: CallForPapersViewModel;
  model: FinalizePaperModel;
  PaperApprovalStatus = PaperApprovalStatus;
  @ViewChild('myForm') myForm: FormGroupDirective;
  //CourseEventStatusEnum = Enums.CourseEventStatusEnum;
  constructor(private route: ActivatedRoute, private cfp: CallForPapersService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.model = new FinalizePaperModel();
    this.route.paramMap.subscribe((params) => {
      this.paperId = +params.get('paperId');
      this.conferenceId = params.get('conferenceSlug');

      this.cfp.getPaperState(this.conferenceId, this.paperId).subscribe((paper) => {
        this.paper = paper;
        this.initialized = true;
      });
    });
  }

  finalizePaper(approved: boolean) {
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      return;
    }

    this.toaster.confirmDialog('Are you sure you want to finalize this paper? This will notifiy the conference organizer.', 'Are you sure?').subscribe((result) => {
      if (result) {

        this.model.approve = approved;

        if (this.instructorStatus == 1) {
          this.model.ceuInstructorStatus = 1;
        }
        if (this.instructorStatus == 0 && this.model.ceuInstructor) {
          this.model.ceuInstructorStatus = 1;
        }

        if (this.instructorStatus == 2) {
          this.model.ceuInstructorStatus = 2;
        }

        this.cfp.finalizePaper(this.conferenceId, this.paperId, this.model).subscribe((result) => {
          this.paper = result;
        });
      }
    });
  }
}
